/** Grymwyrd English copy for the home hero. */
export const homeEn = {
  'home.seoTitle': 'Enter the Twilight',
  'home.seoDescription':
    'Grymwyrd is a living grimdark horror-fantasy RPG world. Forge a hero, explore the bestiary and canon, and carve your legend into the eternal twilight.',
  'home.heroEyebrow': 'A living horror-fantasy world',
  'home.heroTitle': 'Enter the Twilight',
  'home.heroBody':
    'Grymwyrd is a gaslit world of Victorian gothic horror, where the fog-drowned town of Greywick hides ruined towers, manor undercrofts, and rituals best left unspoken. Forge a hero, lift the veils of the Cataclysm, and carve your name into a world that remembers.',
  'home.heroPlayCta': 'Play Now',
  'home.heroBrowseCta': 'Browse Encyclopedia',
  'home.heroQuickstartPrompt': 'Not ready to play? Get the free Quickstart',

  // TodayInGrymwyrd
  'home.today.heading': 'Today in Grymwyrd',

  // LiveFeed
  'home.liveFeed.heading': 'Live from the Veil',
  'home.liveFeed.badge': 'recent canon',
  'home.liveFeed.loading': 'Listening to the dark…',
  'home.liveFeed.actorFallback': 'Someone',
  'home.liveFeed.actionFallback': 'stirred the veil',
  'home.liveFeed.labelAction': 'Player action',
  'home.liveFeed.labelBestiary': 'New bestiary entry',
  'home.liveFeed.labelBook': 'Tome updated',
  'home.liveFeed.empty': 'The veil is still. No fresh canon stirs tonight.',

  // FeaturedBooks
  'home.featuredBooks.heading': 'Featured Tomes',
  'home.featuredBooks.loading': 'Unsealing the library…',
  'home.featuredBooks.empty': 'The library is still being bound — no tomes are on the shelf yet.',
  'home.featuredBooks.descriptionFallback': 'A tome of forbidden knowledge from the eternal twilight.',

  // QuickTools
  'home.quickTools.arsenalTitle': 'The Full Arsenal',
  'home.quickTools.arsenalBody': 'Maps, the bestiary, the dice tower and the living chronicle await beyond the veil.',
  'home.quickTools.arsenalCta': 'Open the Encyclopedia',
  'home.quickTools.encounterTitle': 'Random Encounter',
  'home.quickTools.encounterBody': 'Roll the bones and let the dark decide what crawls from the mist.',
  'home.quickTools.encounterCta': 'Roll an Encounter',
  'home.quickTools.encounterResultHeading': 'An Encounter Emerges',
  'home.quickTools.encounterSilent': 'The dice tower is silent',
  'home.quickTools.encounterSummoning': 'Summoning…',
  'home.quickTools.encounterEmpty': 'No beast answered the call. Roll again to tempt fate.',
  'home.quickTools.clockTitle': 'World Clock',
  'home.quickTools.clockYear': 'Year of the Third Eclipse',
  'home.quickTools.clockAnno': 'Anno Tenebris {year}',
}
